import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/life-general-types/life/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
